import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UsuarioImportacionFormComponent } from './forms/usuario.importacion.form.component';
import { TarifaImportacionFormComponent } from './forms/tarifa.importacion.form.component';
import { EndosoImportacionFormComponent } from './forms/endoso.importacion.form.component';
import { ImportacionMasivaService, ImportacionMasiva } from '../../infrastructure/services/importacionMasiva.service';
import { saveAs } from 'file-saver';

@Component({
  templateUrl: 'seleccionar.tipo.importacion.component.html'
})
export class SeleccionarTipoImportacionComponent implements OnInit {
  @ViewChild('usuario') usuario: UsuarioImportacionFormComponent;
  @ViewChild('tarifa') tarifa: TarifaImportacionFormComponent;
  @ViewChild('endoso') endoso: EndosoImportacionFormComponent;

  importacion: ImportacionMasiva;
  codSistema: string;
  codNegocio: string;
  codProducto: string;
  
  mostrarResultadoImportacion = false;
  resultadosImportacion: Array<any>;

  servicios = ['Usuario', 'Cotizacion', 'Venta', 'Endoso', 'Tarifa'];
  file: any;

  errores = {
    file: null
  };

  constructor(private aRoute: ActivatedRoute,
              private importacionService: ImportacionMasivaService,
              private router: Router) { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.importacion = {
        codSistema: params['codsistema'],
        codNegocio: params['codnegocio'],
        codProducto: params['codproducto'],
        archivo: null,
        tipoImportacion: null,
      };
    });
  }

  seleccionarServicio(servicio) {
    this.importacion.tipoImportacion = servicio;
  }

  openFileChooser() {
    $('#fileUploader').click();
  }

  onFileChange(event) {
    const seleccionoUnaImagen = event.target.files && event.target.files.length > 0;
    if (seleccionoUnaImagen) {
      const reader = new FileReader();
      const file = event.target.files[0];
      this.file = file;
      const extension = file.name ? file.name.split('.').pop() : '';

      // Si el tipo de archivo subido no es valido, retornamos
      const acceptedTypes = ['xls', 'xlsx'];
      if (acceptedTypes.indexOf(extension) < 0) {
        return;
      }

      // Se lee el archivo
      reader.readAsDataURL(file);

      reader.onload = (e: any) => {
        // Obtengo solo la parte de la imagen que es base64
        this.importacion.archivo = e.target.result.replace(/^data:application\/vnd.ms-excel;base64,/, ''); ;
        this.errores.file = null;
      };
    }
  }

  enviar() {
    if (!this.esFormValido()) {
      return;
    }
    this.construirFormData();

    this.importacionService
      .enviarDatosImportacion(this.importacion)
      .then(resultado => {
        this.mostrarResultadoImportacion = true;
        this.resultadosImportacion = resultado;
      });
  }

  esFormValido() {
    let esValido = true;

    if (!this.file) {
      this.errores.file = 'VALOR_REQUERIDO';
      esValido = false;
    }

    if (!this.esValidoFormularioSeleccionado()) {
      esValido = false;
    }

    return esValido;
  }

  esValidoFormularioSeleccionado() {
    if (this.importacion.tipoImportacion === 'Usuario') {
      return this.usuario.validar();
    }

    if (this.importacion.tipoImportacion === 'Endoso') {
      return this.endoso.validar();
    }

    if (this.importacion.tipoImportacion === 'Tarifa') {
      return this.tarifa.validar();
    }

    return true;
  }

  construirFormData() {
    if (this.importacion.tipoImportacion === 'Usuario') {
      this.importacion.requestConfiguracionUsuario =  this.usuario.getFormData();
    }

    if (this.importacion.tipoImportacion === 'Endoso') {
      this.importacion.requestConfiguracionEndoso = this.endoso.getFormData();
    }

    if (this.importacion.tipoImportacion === 'Tarifa') {
      const tarifaData = this.tarifa.getFormData();
      this.importacion.tarifaV5_Tipo = tarifaData.tipo;
      this.importacion.tarifaV5_IdTabla = tarifaData.idTabla;
    }
  }

  descargarLayout() {
    this.construirFormData();
    this.importacionService.generarLayout(this.importacion)
      .then(fileName => {
        this.importacionService.descargarLayout(fileName)
          .then(response => {
            this.downloadExcelFile(response);
          });
      });
  }

  download(content, filename, contentType) {
    const blob = new Blob([content], { 'type': contentType });
    saveAs(blob, filename);
  }

  downloadExcelFile(data) {

    // base64 To ArrayBuffer
    var binaryString = atob(data.fileContents);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    // -------

    this.download(bytes, data.fileDownloadName, data.contentType);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/importacionMasiva/seleccionar.tipo.importacion.component.ts